
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import LeadTabulationService from "@/services/lead/LeadTabulationService";
import StatusService from "@/services/lead/StatusService";
import vSelect from "vue-select";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import ChannelService from '../services/lead/ChannelService';
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    vSelect
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class LeadTabulation extends Vue {

  private leadTabulationService = new LeadTabulationService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private leadTabulationList: any;

  /**
   * @type Object
   * Status list returned from backend routes
   */
  private statusList: any = [];
  private relatedStatusList: any = [];

  /**
   * Channel list
   */
  private relatedChannelList: any = [];

  /**
   * @type Object
   * insert/edit Lead Tabulation
   */
  private leadTabulation: any = {
    id_lead_tabulation: null,
    name: null,
    description: null,
    relatedStatus: null,
    relatedChannel: null,
    status: null,
    isAutonomous: null,
    platformId: this.$auth.user().id_platform
  };

  private self;

  /**
   * @type object
   * Help control error form for send or not
   */
  private leadTabulationFormError: object = {
    name: { state: null, message: "Campo Obrigatório" },
    description: { state: null, message: "Campo Obrigatório" },
    relatedStatus: { state: null, message: "Campo Obrigatório" },
    relatedChannel: { state: null, message: "Campo Obrigatório" },
    status: { state: null, message: "Campo Obrigatório" }
  };

  /**
   * @type
   * Help to control show loading icon
   */
  private loading: boolean = false;
  private editing: boolean = false;

  /**
   * @tyoe Array
   * Define columns from datatables
   */
  private columns = [
    { data: "id_lead_tabulation", name: "id_lead_tabulation", title: "ID", orderable: true, visible: false },
    {
      data: "name",
      name: "name",
      title: "Nome",
      orderable: true,
      defaultContent: "--",
      searchable: true
    },
    { data: "description", name: "description", title: "Descrição", orderable: true },
    { data: "fk_id_related_status", name: "related_status", title: "Status", orderable: true, defaultContent: "--" },
    { data: "fk_id_related_channel", name: "related_channel", title: "Canal", orderable: true },
    { data: "fk_id_status", name: "status", title: "Situação", orderable: true, defaultContent: "--" },
    { data: "is_autonomous", name: "is_autonomous", title: "Bot", orderable: true, defaultContent: "--" },
    { data: "actions", name: "actions", title: "Ações", orderable: false, defaultContent: "--", visible: true  }
  ];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];
  public leadTabulation_is_autonomous:any = [];
  /**
   * Method created life cycle
   */
  private created() {
  }

  private get descriptionState() {
    if (this.leadTabulation["description"] != null) {
      this.leadTabulationFormError["description"].state =
        (this.leadTabulation["description"] != null && this.leadTabulation["description"] != "") ? true : false;
    }
    return this.leadTabulationFormError["description"].state;
  }

  private get tabulationState() {
    if (this.leadTabulation["name"] != null) {
      this.leadTabulationFormError["name"].state =
        (this.leadTabulation["name"] != null && this.leadTabulation["name"] != "") ? true : false;
    }
    return this.leadTabulationFormError["name"].state;
  }

  private get relatedStatusState() {
    if (this.leadTabulation["relatedStatus"] != null) {
      this.leadTabulationFormError["relatedStatus"].state =
        (this.leadTabulation["relatedStatus"] != null) ? true : false;
    }
    return this.leadTabulationFormError["relatedStatus"].state;
  }

  private get relatedChannelState() {
    if (this.leadTabulation["relatedChannel"] != null) {
      this.leadTabulationFormError["relatedChannel"].state =
        (this.leadTabulation["relatedChannel"] != null) ? true : false;
    }
    return this.leadTabulationFormError["relatedChannel"].state;
  }

  private get statusState() {
    if (this.leadTabulation["status"] != null) {
      this.leadTabulationFormError["status"].state =
        (this.leadTabulation["status"] != null) ? true : false;
    }
    return this.leadTabulationFormError["status"].state;
  }

  /**
   * Method for validation form add tabulation
   */
  private validateForm() {
    for (let elem in this.leadTabulationFormError) {
      this.leadTabulationFormError[elem].state =
        (this.leadTabulation[elem] != null && this.leadTabulation[elem] != "") ? true : false;
    }
  }

  private formSubmit() {
    return this.editing ? this.updateLeadTabulation() : this.addLeadTabulation();
  }

  /**
   * Method for add new tabulation
   */
  private addLeadTabulation() {
    this.validateForm();
    for (let elem in this.leadTabulationFormError) {
      if (this.leadTabulationFormError[elem].state != true)
        return;
    }

      this.loading = true;

    let requestBody = {
      name: this.leadTabulation.name,
      description: this.leadTabulation.description,
      fk_id_related_status: this.leadTabulation.relatedStatus.id_status,
      fk_id_related_channel: this.leadTabulation.relatedChannel.id_channel,
      fk_id_status: this.leadTabulation.status.id_status,
      is_autonomous: this.leadTabulation_is_autonomous.includes("1") ? 1 : 0
    }

    this.leadTabulationService.store(requestBody).then((res: any) => {
      if (JSON.stringify(res).toLowerCase().indexOf("success") !== -1) {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Tabulação adicionada com sucesso!');
        this.leadTabulationList.ajax.reload();
      } else {
        this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao adicionar tabulação.');
      }
      this.loading = false;
      this.closeLeadTabulationModal();
    });
  }

  /**
   * Method for add new tabulation
   */
  private updateLeadTabulation() {
    this.validateForm();
    for (let elem in this.leadTabulationFormError) {
      if (this.leadTabulationFormError[elem].state != true)
        return;
    }

    this.loading = true;

    let requestBody = {
      name: this.leadTabulation.name,
      description: this.leadTabulation.description,
      fk_id_related_status: this.leadTabulation.relatedStatus.id_status,
      fk_id_related_channel: this.leadTabulation.relatedChannel.id_channel,
      fk_id_status: this.leadTabulation.status.id_status,
      is_autonomous: this.leadTabulation_is_autonomous.includes("1") ? 1 : 0
    }

    this.leadTabulationService.update(this.leadTabulation.id_lead_tabulation, requestBody).then((res: any) => {
      if (JSON.stringify(res).toLowerCase().indexOf("success") !== -1) {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Tabulação modificada com sucesso!');
        this.leadTabulationList.ajax.reload();
      } else {
        this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao modificar usuário.');
      }
      this.loading = false;
      this.closeLeadTabulationModal();
    });
  }

  /**
   * Method close modal from add new lead tabulation
   */
  private closeLeadTabulationModal() {
    this.hideModal("modal-add-lead-tabulation");
    this.leadTabulation.description = null;
    this.leadTabulation.name = null;
    this.leadTabulation.status = null;
    this.leadTabulation.relatedStatus = null;
    this.leadTabulation.relatedChannel = null;
    this.leadTabulation.isAutonomous = null;
    this.leadTabulation_is_autonomous = null;

    this.leadTabulationFormError["description"].state = null;
    this.leadTabulationFormError["name"].state = null;
    this.leadTabulationFormError["status"].state = null;
    this.leadTabulationFormError["relatedStatus"].state = null;
    this.leadTabulationFormError["relatedChannel"].state = null;

    this.editing = false;
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(self) {
    this.self = self;
    if (self.allowedFeature('create-tabulation')) {
      this.buttons.push({ extend: "addLeadTabulation" });
    }else{
        this.columns.filter(e => e.name !== 'actions');
    }

    this.leadTabulationList = this.$('#leadTabulationList').DataTable({
      autoWidth: false,
      responsive: true,
      processing: true,
      lengthMenu: [
        [25, 50, 100],
        [25, 50, 100],
      ],
      pageLength: 25,
      scrollY: 500,
      scrollX: true,
      searching: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + "lead/tabulation",
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },
      columnDefs: [
        {
          className: "nowrap",
          targets: [1, 2]
        },
        {
          className: "nowrap",
          render: (data, type, row) => {
            for (let relatedStatus of this.relatedStatusList) {
              if (relatedStatus.id_status == data)
                return relatedStatus.label;
            }
          },
          targets: 3
        },
        {
          className: "nowrap",
          render: (data, type, row) => {

            for (let channel of this.relatedChannelList) {
              if (channel.id_channel == data)
                return channel.label;
            }
          },
          targets: 4
        },
        {
            className: "nowrap",
            render: (data, type, row) => {

                for (let status of this.statusList) {
                    if (status.id_status == data)
                        return status.label;
                }
            },
            targets: 5
        },
        {
            className: "nowrap",
            render: (data, type, row) => {
                return row.is_autonomous == 1 ? 'Sim' : 'Não';
            },
            targets: 6
        },
        {
          className: "nowrap dt-right",
          render: (data, type, row) => {
            let buttons = "";
            if(self.allowedFeature('edit-tabulation')){
                buttons +=
                "<button class='editButton' type='button' style='padding: 0; border: 0; background-color: transparent;'><i class='far fa-edit'></i></button>&nbsp;";
            }
            return buttons;
          },
          targets: 7
        }
      ],
      columns: this.columns,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.leadTabulation.id_lead_tabulation = this.leadTabulationList
            .row(this.$(e.target).parents("tr"))
            .data().id_lead_tabulation;
          this.leadTabulation.description = this.leadTabulationList
            .row(this.$(e.target).parents("tr"))
            .data().description;
          this.leadTabulation.name = this.leadTabulationList
            .row(this.$(e.target).parents("tr"))
            .data().name;
          for (let relatedStatus of this.relatedStatusList) {
            if (relatedStatus.id_status == this.leadTabulationList
              .row(this.$(e.target).parents("tr"))
              .data().fk_id_related_status)
              this.leadTabulation.relatedStatus = relatedStatus;
          }
          for (let relatedChannel of this.relatedChannelList) {
            if (relatedChannel.id_channel == this.leadTabulationList
              .row(this.$(e.target).parents("tr"))
              .data().fk_id_related_channel)
              this.leadTabulation.relatedChannel = relatedChannel;
          }
          for (let status of this.statusList) {
            if (status.id_status == this.leadTabulationList
              .row(this.$(e.target).parents("tr"))
              .data().fk_id_status)
              this.leadTabulation.status = status;
          }
          this.leadTabulation.isAutonomous = this.leadTabulationList.row(this.$(e.target).parents("tr")).data().is_autonomous;
          this.leadTabulation_is_autonomous = !!this.leadTabulationList.row(this.$(e.target).parents("tr")).data().is_autonomous;
          this.leadTabulation_is_autonomous = [this.leadTabulationList.row(this.$(e.target).parents("tr")).data().is_autonomous];
          
          if(this.self.allowedFeature('edit-tabulation')){
          this.editing = true;
          this.$bvModal.show("modal-add-lead-tabulation");
          }
        });
      }
    });

    this.leadTabulationList
      .buttons()
      .container()
      .appendTo("#dt-actions");
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;

    this.$.fn.dataTable.ext.buttons.addLeadTabulation = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0 border-10",
      titleAttr: "Adicionar tabulação",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-lead-tabulation");
      }
    }

    let statusService: StatusService = new StatusService();
    let channelService: ChannelService = new ChannelService();
    let statusPromise = statusService.group(6);
    let relatedStatusPromise = statusService.group(1);
    let relatedChannelPromise = channelService.index();

    Promise.all([statusPromise, relatedStatusPromise, relatedChannelPromise]).then(values => {
      this.statusList = values[0];
      this.relatedStatusList = values[1].filter(e => !(["lead_pending", "lead_worked", "lead_self_finished_sale"].includes(e.name)));
      this.relatedChannelList = values[2];
      this.createDataTable(this);
    });

  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }
}
